import render from './render'

import createRender from './createRender'

render.createRender = createRender

export default render
